module.exports = __webpack_public_path__ + "static/img/submitInfo.d10614e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/submitInfo.png
// module id = IvYT
// module chunks = 1